/**
 * Shaping helpers for analytics properties. Buckets and caps live here so every
 * call site sends the same values — a bucket boundary that drifted between two
 * sites would make the funnels lie, and the event names are unrenameable.
 */

import { getFileExtension } from "@/domains/documents/constants/fileTypes";

/** Lower-cased extension, no dot, capped so a pathological filename can't
 *  become a high-cardinality property. */
export function fileExtProp(filename: string | null | undefined): string {
  return getFileExtension(filename).slice(0, 10);
}

export function sizeBucket(bytes: number): "lt1mb" | "1_10mb" | "10_100mb" | "gt100mb" {
  if (bytes < 1_000_000) return "lt1mb";
  if (bytes < 10_000_000) return "1_10mb";
  if (bytes < 100_000_000) return "10_100mb";
  return "gt100mb";
}

export function changeCountBucket(count: number): "0" | "1_10" | "11_100" | "gt100" {
  if (count <= 0) return "0";
  if (count <= 10) return "1_10";
  if (count <= 100) return "11_100";
  return "gt100";
}
